import styled from '@emotion/styled'

export const Container = styled.div`
	min-width: 360px;
	${({ theme }) => `
		background-color: ${theme.palette.backgroundColors.lighterGrey};
	`}
	border-radius: 4px;
	padding: 1.5rem;
	height: 600px;
`

export const BreakdownBox = styled.div``
